import React from 'react';
import {findDOMNode} from "react-dom";
import Popover from "../../../../../../core/gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../../core/gd-components/gd-popover/popover-position";
import {PopoverAttachmentType} from "../../../../../../core/gd-components/gd-popover/@const";
import FieldTextEditForm from "./edit-form";
import FieldProto from "../../../../proto/field-proto";


type Props = {
    parent  : any,
    field   : FieldProto
    value   : string | null
    onSave  : callback
}

export default function FieldText_Popover(props: Props) {

    const onSave = (value: string) => {
        props.onSave(value)
    }

    const popoverPosition = new PopoverPosition({
        attachment      : 'top center',
        targetAttachment: 'bottom center',
        attachmentType  : PopoverAttachmentType.HORIZONTAL,
    })

    return (
        <Popover popoverClass="gd-field-text-edit-popover"
                 className="gd-field-text-edit-popover-container"
                 position={popoverPosition}
                 getTargetFunc={() => findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>

            <FieldTextEditForm text={props.value} onSave={onSave}/>

        </Popover>
    )
}
